import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/buttons/button";
import "../../../../styles/pages/postulationState.scss";
import { callApi, saveCvExperience } from "../../../../services/apiService";
import MainContainer from "../../../../layouts/container/mainContainer";
import Modal from "@mui/material/Modal";
import { NotificationManager } from "react-notifications";
import { FormProvider, useForm } from "react-hook-form";
import DateInput from "../../../../components/forms/inputs/dateInput";

const CvExperienceModal = ({
  userId,
  cvId,
  dataCvExperience,
  setDataCvExperience,
  open,
  close,
  loadDataCv,
}) => {
  const { t } = useTranslation();
  const [botonActivo, setBotonActivo] = useState(false);

  useEffect(() => {
    if (!open) {
      setDataCvExperience(null);
      return;
    }
    if (dataCvExperience != null) {
      setValue("companyName", dataCvExperience.companyName);
      setValue("location", dataCvExperience.location);
      setValue("position", dataCvExperience.position);
      setValue("duties", dataCvExperience.duties);
      setValue(
        "startDate",
        !dataCvExperience || !dataCvExperience.startDate
          ? ""
          : new Date(dataCvExperience.startDate)
      );
      setValue(
        "endDate",
        !dataCvExperience || !dataCvExperience.endDate
          ? ""
          : new Date(dataCvExperience.endDate)
      );
    }
  }, [open]);

  const defaultValues = {};
  const methods = useForm({ defaultValues });
  const {
    control,
    register,
    setValue,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = methods;

  const validations = {
    companyName: {
      required: { value: true, message: t("healthInfo.required") },
    },
    location: {
      required: { value: true, message: t("healthInfo.required") },
    },
    position: {
      required: { value: true, message: t("healthInfo.required") },
    },
    duties: {
      required: { value: true, message: t("healthInfo.required") },
    },
    startDate: {
      required: { value: true, message: t("healthInfo.required") },
    },
  };

  const clearData = () => {
    setValue("companyName", "");
    setValue("location", "");
    setValue("position", "");
    setValue("duties", "");
    setValue("startDate", "");
    setValue("endDate", "");
  };

  const handleClose = () => {
    clearData();
    setDataCvExperience(null);
    reset();
    close();
  };

  const onSubmit = handleSubmit((data) => {
    const dataToSave = {
      id: dataCvExperience == null ? 0 : dataCvExperience.id,
      cvId: cvId == null ? 0 : cvId,
      userId: parseInt(userId),
      companyName: data.companyName,
      location: data.location,
      position: data.position,
      positionDetails: data.duties,
      startDate: data.startDate,
      endDate: data.endDate,
    };

    callApi(
      () => saveCvExperience(dataToSave),
      () => {
        NotificationManager.success(t("form.success"));
        loadDataCv();
        handleClose();
      }
    );
  });

  return (
    <>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MainContainer showImage={false} class="ww-container-xl">
          <h1 className="title">{}</h1>
          <FormProvider {...methods}>
            <form>
              <div className="container-inputs">
                <div className="inputs-style">
                  <label>
                    {t("cvExperience.company")}
                    <span className="text-danger"> *</span>
                  </label>
                  <input
                    placeholder={t("cvExperience.company")}
                    className="form-control mb-2"
                    name="companyName"
                    {...register("companyName", validations.companyName)}
                  />
                  <span className="text-danger text-small d-block mb-2">
                    {errors.companyName && errors.companyName.message}
                  </span>
                </div>
                <div className="inputs-style">
                  <label>
                    {t("cvEducation.city")}
                    <span className="text-danger"> *</span>
                  </label>
                  <input
                    placeholder={t("cvEducation.city")}
                    className="form-control mb-2"
                    name="location"
                    {...register("location", validations.location)}
                  />
                  <span className="text-danger text-small d-block mb-2">
                    {errors.location && errors.location.message}
                  </span>
                </div>
              </div>
              <div className="container-inputs">
                <div className="inputs-style">
                  <DateInput
                    name="startDate"
                    maxDate={new Date()}
                    control={control}
                    placeholder={t("cvEducation.startDate")}
                    label={
                      <label>
                        {t("cvEducation.startDate")}
                        <span className="text-danger"> *</span>
                      </label>
                    }
                    {...register("startDate", validations.startDate)}
                  />
                  <span className="text-danger text-small d-block mb-2">
                    {errors.startDate && errors.startDate.message}
                  </span>
                </div>
                <div className="inputs-style">
                  <DateInput
                    name="endDate"
                    minDate={watch("startDate")}
                    control={control}
                    placeholder={t("cvEducation.endDate")}
                    label={<label>{t("cvEducation.endDate")}</label>}
                    {...register("endDate", validations.endDate)}
                  />
                </div>
              </div>
              <div className="container-inputs">
                <div className="inputs-style">
                  <label>
                    {t("cvExperience.position")}
                    <span className="text-danger"> *</span>
                  </label>
                  <input
                    placeholder={t("cvExperience.position")}
                    className="form-control mb-2"
                    name="position"
                    {...register("position", validations.position)}
                  />
                  <span className="text-danger text-small d-block mb-2">
                    {errors.position && errors.position.message}
                  </span>
                </div>
                <div className="inputs-style">
                  <label>
                    {t("employer.positionDetails")}
                    <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    name="duties"
                    placeholder={t("employer.positionDetails")}
                    className="form-control mb-2"
                    registerOptions={validations}
                    rows="2"
                    {...register("duties", validations.duties)}
                  ></textarea>
                  <span className="text-danger text-small d-block mb-2">
                    {errors.duties && errors.duties.message}
                  </span>
                </div>
              </div>
              <div className="btn-container">
                <Button
                  type="ww-btn-secondary"
                  size="btn-sx"
                  label={t("main.close")}
                  onClick={() => {
                    handleClose();
                  }}
                />
                <Button
                  size="btn-sx"
                  label={t("main.getInto")}
                  onClick={onSubmit}
                />
              </div>
            </form>
          </FormProvider>
        </MainContainer>
      </Modal>
    </>
  );
};

export default CvExperienceModal;
